import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { getBlogById } from "../../Api/blog";
import { API_URL } from "../../Config/environment";
import Section from "../Section";
import Breadcrumb from "../Breadcrumb";
import Spacing from "../Spacing";
import Sidebar from "../Sidebar";
import BannerSectionStyle9 from "../Section/BannerSection/BannerSectionStyle9";
import { Icon } from "@iconify/react";

export default function BlogDetails() {
  const { blogId } = useParams();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchBlog() {
      try {
        setLoading(true);
        console.log("Fetching blog for id:", blogId);
        const res = await getBlogById(blogId);
        console.log("Fetched blog data:", res);
        setBlog(res?.blog || res?.data?.blog || res); // handles multiple API shapes
      } catch (err) {
        console.error("Error fetching blog details:", err);
      } finally {
        setLoading(false);
      }
    }

    if (blogId) fetchBlog();
  }, [blogId]);

  if (loading) return <p className="text-center mt-20">Loading blog...</p>;
  if (!blog) return <p className="text-center mt-20 text-red-500">Blog not found.</p>;

  return (
    <Section topMd={150}
      topLg={70}
      topXl={50}>
      {/* Header Section */}
      <Section topMd={170} bottomMd={54} bottomLg={54}>
        <Breadcrumb title={blog.title || "Blog Details"} />
      </Section>

      <div className="container">
        {/* Blog Meta */}
        <div className="cs_blog_details_info flex flex-wrap items-center justify-between">
          <div className="cs_blog_details_info_left">
            <div className="text-sm text-gray-500">
              {new Date(blog.createdAt).toLocaleDateString("en-US", {
                year: "numeric",
                month: "long",
                day: "2-digit",
              })}
            </div>
          </div>
          <div className="cs_social_links_wrap flex items-center gap-3">
            <h2 className="text-base font-semibold">Share:</h2>
            <div className="cs_social_links flex gap-2">
              <Link to="https://www.facebook.com/GKCklinica/" className="hover:text-blue-600">
                <Icon icon="fa-brands:facebook-f" />
              </Link>
              <Link to="https://x.com/GkcKlinica">
                <Icon icon="fa-brands:twitter" />
              </Link>
              <Link to="https://www.instagram.com/gkcklinica/">
                <Icon icon="fa-brands:instagram" />
              </Link>
              <Link to="https://www.linkedin.com/uas/login?session_redirect=%2Fcompany%2F102332936%2F" className="hover:text-blue-700">
                <Icon icon="fa-brands:linkedin-in" />
              </Link>
            </div>
          </div>
        </div>

        <Spacing md="55" />

        {/* Blog Images */}
        {blog.imageUrl?.length > 0 && (
          <div className="flex flex-wrap gap-4 mb-6">
            {blog.imageUrl.map((img, i) => (
              <img
                key={i}
                src={img.startsWith("http") ? img : `${API_URL}/uploads/blogs/${img}`}
                alt={blog.title}
                className="w-full md:w-[48%] rounded-xl shadow-sm"
              />
            ))}
          </div>
        )}

        <Spacing md="40" />

        <div className="row">
          {/* Blog Content */}
          <div className="col-lg-8">
            <div className="cs_blog_details prose max-w-none">
              <h1 className="text-4xl font-bold mb-3">{blog.title}</h1>
              {blog.subTitle && (
                <p className="text-gray-500 text-lg mb-6 italic">{blog.subTitle}</p>
              )}
              <div
                className="leading-relaxed text-gray-700"
                dangerouslySetInnerHTML={{ __html: blog.description }}
              />
            </div>
          </div>

          {/* Sidebar */}
          {/* <div className="col-lg-4">
            <Sidebar />
          </div> */}
        </div>

        <Spacing md="135" lg="100" />

        {/* Footer Banner */}
        {/* <h2 className="mb-0 cs_fs_40 cs_medium">Related Articles</h2>
        <Spacing md="57" />
        <p className="text-gray-500 mb-10">
          More articles will appear here soon.
        </p> */}
      </div>

      <Spacing md="200" xl="150" lg="110" />

      {/* <Section className="cs_footer_margin_0">
        <BannerSectionStyle9
          title="Don’t Let Your Health <br />Take a Backseat!"
          subTitle="Schedule an appointment with one of our experienced <br />medical professionals today!"
          imgUrl="/images/doctors/banner_img_3.png"
        />
      </Section> */}
    </Section>
  );
}

